import { create } from "zustand";

const useStore = create((set) => ({
  store: {
    homeData: {
      slides: [
        {
          id: 1, // Assign unique IDs
          title: "Omron E3Z D62 Photoelectric Sensor",
          subtitle: "High-performance diffuse-reflective sensor.", // Add a suitable subtitle
          image:
            "https://5.imimg.com/data5/SELLER/Default/2021/2/CM/QT/ID/42713251/omron-e3z-d62-500x500.jpg", // Replace with actual image URL if available
          linkTitle: "Get Best Quote",
          link: "/products", // Link to contact page or specific quote request page
        },
        {
          id: 2,
          title: "Omron Photoelectric Sensor",
          subtitle: "Reliable detection for industrial automation.", // Add a suitable subtitle
          image:
            "https://5.imimg.com/data5/SELLER/Default/2021/2/ZT/WD/UL/42713251/omron-photoelectric-sensor-500x500.jpg", // Replace with actual image URL
          linkTitle: "Get Best Quote",
          link: "/products",
        },
        {
          id: 3,
          title: "Fotek A3R-2MX Photoelectric Sensor",
          subtitle: "Compact and versatile sensing solution.", // Add a suitable subtitle
          image:
            "https://5.imimg.com/data5/SELLER/Default/2021/2/PB/ML/AQ/42713251/fotek-a3r-2mx-photoelectric-sensor-500x500.jpg", // Replace with actual image URL
          linkTitle: "Get Best Quote",
          link: "/products",
        },
        {
          id: 4,
          title: "Plc Based Control Panels",
          subtitle: "Three phase industrial 415 V upto 2000 Amps", // Add a suitable subtitle
          image:
            "https://5.imimg.com/data5/SELLER/Default/2023/3/294304609/PT/PX/GP/42713251/330472814-1440218033178046-519564935702278796-n-500x500.jpeg", // Replace with actual image URL
          linkTitle: "Get Best Quote",
          link: "/services",
        },
        {
          id: 5,
          title: "HMI Digital Touch Panel",
          subtitle: "Intuitive control for your automation systems.", // Add a suitable subtitle
          image:
            "https://5.imimg.com/data5/SELLER/Default/2021/2/RI/QC/FD/42713251/hmi-digital-touch-panel-500x500.jpg", // Replace with actual image URL
          linkTitle: "Get Best Quote", // Or perhaps "View Details" if it links to a product page
          link: "/products", // Or link to HMI product category/detail page if available
        },
        // Add more products formatted like this
      ],
      companyDetails: {
        title: "Welcome to the Inovia Automation",
        details:
          "We introduce ourselves as, M/s. Inovia Automation a Sole Proprietary Company established professional supplier of automation products with engineering solutions for Factory Automation and Process Automation in 2020 having strength of 4 applications orientedexperienced engineers with 5-6 years domain experience.We are committed to provide innovative engineering solutions for the needs of variable automation, electrical & electronic equipment. Applying High-Technology, automatic management and production aim to maximizing the business effect.",
        image:
          "https://static.vecteezy.com/system/resources/previews/025/466/188/non_2x/integration-data-system-system-integration-technology-concept-in-robotic-hand-industrial-and-smart-technology-business-and-automation-solutions-illustration-vector.jpg",
        link: "about",
        linkTitle: "About Us",
      },
      foundersDetails: {
        image:
          "https://pbs.twimg.com/media/EVlksS5XsAEJmaS?format=jpg&name=small",
        title: "",
        subTitle:
          "Inovia Automation is a leading Industrial Automation Supplier with Engineering solutions !",
        description:
          "Starting with a modest team of 4 application-oriented engineers, Yogesh Raskar envisioned creating a company that not only supplied automation products but also delivered end-to-end engineering solutions. His aim is to bridge the gap between industrial needs and modern technological solutions through transparent business practices, timely execution, and customer satisfaction.",
        name: "Yogesh Raskar",
        position: "Founder",
      },
      products: [
        {
          category: "Non-Wovens",
          title: "SpringBond®",
          subtitle: "The PU foam replacement technology for underlay",
          hoverText: "Learn More",
          brand: "UITRAFlex®",
          link: "products",
        },
        {
          category: "Non-Wovens",
          title: "SpringBond UltraFlex®",
          subtitle: "Bespoke high-performance foam replacement solutions",
          hoverText: "Explore Solutions",
          brand: "UITRAFlex®",
          link: "products",
        },
        {
          category: "Flores & Filtings",
          title: "Hollow Conjugate Fibres",
          subtitle: "Spring-like structure for superior comfort and resilience",
          hoverText: "Discover Technology",
          brand: "UITRAFlex®",
          link: "products",
        },
        {
          category: "Flores & Filtings",
          title: "Carded Fibres",
          subtitle: "Soft, uniformly processed fibre ideal for hand-filling",
          hoverText: "View Details",
          brand: "UITRAFlex®",
          link: "products",
        },
        {
          category: "Flores & Filtings",
          title: "Carded Fibres",
          subtitle: "Soft, uniformly processed fibre ideal for hand-filling",
          hoverText: "View Details",
          brand: "UITRAFlex®",
          link: "products",
        },
      ],
      productsSliderHeading: "Our Products Category",
      mainScrollText: {
        text: "If a job’s worth doing, it’s worth doing well",
        className:
          "md:h-screen px-6 md:py-0 py-14 md:px-0 text-center max-w-[1000px] mx-auto",
        author: "Yogesh Raskar",
        position: "founder",
        bgColor: "#eee",
        fgColor: "black",
        fontSize: "text-8xl",
        forward: true,
      },
      services: [
        {
          title: "Upholstery",
          details: "More Details",
          image:
            "https://www.scio-automation.com/hubfs/Blogbeitrag%20Bilder%20%281%29.png",
          link: "services",
        },
        {
          title: "Soft Furnishings",
          details: "More Details",
          image:
            "https://www.jabil.com/dam/jcr:6c11d469-8661-4c23-928e-8fd50be34d0e/Advanced%20Automation.jpg",
          link: "services",
        },
        {
          title: "Flooring",
          details: "More Details",
          image:
            "https://www.scio-automation.com/hubfs/Blogbeitrag%20Bilder%20%281%29.png",
          link: "services",
        },
        {
          title: "Bedding",
          details: "More Details",
          image:
            "https://www.jabil.com/dam/jcr:6c11d469-8661-4c23-928e-8fd50be34d0e/Advanced%20Automation.jpg",
          link: "services",
        },
      ],
      serviceSliderHeading: "Our Service Category",
      aspirations: [
        {
          title: "Our Vision",
          points: [
            `<b>To be a trusted partner: </b>
                By prioritizing customer satisfaction and delivering quality,
                reliable, and timely solutions.`,

            `<b>Building lasting relationships: </b>
                Through honesty, transparency, and trust with our clients and
                partners.`,

            `<b>Effective collaboration: </b>
                Across industries, ensuring seamless execution and mutual
                growth.`,
            `<b>Continuous improvement: </b>
                In our products and services, exceeding expectations and setting
                industry standards.`,
          ],
        },
        {
          title: "Our Mission",
          points: [
            `<b>Delivering high-quality products: </b>
                that meet our clients' unique needs, ensuring their success.`,

            `<b>Operating with honesty and transparency: </b>
                Fostering trust in every partnership.`,

            ` <b>Working collaboratively: </b>
                Respecting each role and aligning efforts toward shared goals.`,
            `<b>Commitment to continuous improvement: </b>
                Providing reliable solutions that surpass expectations.`,
          ],
        },
        {
          title: "Our Values",
          points: [
            `<b>Customer-Centric Approach: </b>
                We prioritize understanding and fulfilling our customers'
                requirements, ensuring their satisfaction and success.`,

            `<b>Teamwork: </b>
                We collaborate effectively, respecting each other's roles and
                maintaining a unified focus on our collective goals.`,

            `<b>Integrity: </b>
                We uphold honesty and transparency in all our dealings, building
                trust with clients and partners.`,
            `<b>Excellence: </b>
                We strive for continuous improvement, delivering products and
                services that exceed expectations.`,
          ],
        },
      ],
      aspirationsbg:
        "https://www.scio-automation.com/hubfs/Blogbeitrag%20Bilder%20%281%29.png",
      contactUs: {
        image:
          "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg?w=1920&h=0&crop=1",
        headline: `Let’s get <br /> our heads <br /> together`,
        helpHeading: "How Can We Help?",
        description:
          "Contact us to be your automation partner in all things industrial automation, control systems, and innovative solutions.",
        link: "contact",
        linkTitle: "Contact Us",
      },
    },
    aboutData: {
      heading_about: "About Us",
      heading_title: "Our Story",
      heading_description_1: [
        "Yogesh Raskar is the Founder and CEO of Inovia Automation, a leading name in the field of Industrial Automation solutions. With a strong vision to revolutionize automation services, Yogesh Raskar established the company in 2020 with a team of highly experienced engineers specializing in factory and process automation.",
        "Drawing upon over 5-6 years of domain expertise, Yogesh Raskar has built Inovia Automation on the pillars of innovation, technical excellence, and customer-centric solutions. His leadership emphasizes applying high-end technologies to maximize business efficiency for industries across sectors.",
      ],
      large_text: "Vision",
      image:
        "https://thinkgroupuk.co.uk/wp-content/uploads/2024/10/lightbulb.jpg",
      heading_description_2: [
        "Starting with a modest team of 4 application-oriented engineers, Yogesh Raskar envisioned creating a company that not only supplied automation products but also delivered end-to-end engineering solutions. His aim is to bridge the gap between industrial needs and modern technological solutions through transparent business practices, timely execution, and customer satisfaction.",
      ],
      valueCards: [
        {
          image:
            "https://as1.ftcdn.net/jpg/02/89/03/16/1000_F_289031631_Jf7Rotuqrz6OSnV2O5UxaPJZsbEi7IwH.jpg",
          title: "Understand",
          description:
            "A professional approach through active listening and a deep dive into customers requirements and offering them proven solutions from industry leaders.",
        },
        {
          image:
            "https://miro.medium.com/v2/resize:fit:538/1*sQSJdJPvv6iXrb3OGpSsQg.jpeg",
          title: "Deliver",
          description:
            "We are committed to working with the highest ethical standards and delivering our customers the best experience.",
        },
        {
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwupBfT7709gUhTeAG0ZdKq2MrwJKCWLtc6g&s",
          title: "Support",
          description:
            "Our commitment doesn’t end with delivery. We provide ongoing support and service, ensuring that your equipment runs smoothly and continues to meet your needs.",
        },
      ],
      mainScrollText: {
        text: "True success begins with understanding. By listening deeply and exploring every requirement, we uncover the real needs behind every request.Understanding isn't just about hearing words — it's about connecting with people, building trust, and creating solutions that truly make a difference",
        className: "py-20 px-6 md:px-0",
        author: "Abhi Raskar",
        position: "CEO",
        bgColor: "#eee",
        fgColor: "black",
        fontSize: "text-6xl",
        authorColor: "text-white",
        forward: false,
      },
      teamHeading: "Meet Our Team",
      teamInfo: [
        {
          name: "Yogesh Raskar",
          role: "Founder",
          image:
            "https://pbs.twimg.com/media/EVlksS5XsAEJmaS?format=jpg&name=small",
        },
        {
          name: "Abhi Raskar",
          role: "CEO",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJoc75H_GOAlOOuZw_H4a9QJ-yR7urqTrT8w&s",
        },
       
      ],
    },
    serviceData: {
      serviceHeading: "Services",
      bgImage:
        "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg",
      serviceList: [
        {
          id: 1,
          title: "lorem ipsum dolor sit amet, consectetur adipiscing",
          sector: "Apparel",
          imageUrl:
            "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg",
          bannerImageUrl:
            "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg",
          hightLight_text:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corporis ab, iste natus fuga, qui voluptate dolor beatae esse nesciunt ad autem error, temporibus accusantium eos tempora! Inventore similique esse nostrum!",
          buttonText: "More Details",
          description: [
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem nostrum doloremque nihil qui, dolores voluptatum distinctio a! Ducimus tempora nisi minus dolore! Omnis facere illo blanditiis quis eius, quibusdam dicta.",
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem nostrum doloremque nihil qui, dolores voluptatum distinctio a! Ducimus tempora nisi minus dolore! Omnis facere illo blanditiis quis eius, quibusdam dicta.",
          ],

          images: [
            {
              src: "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg",
              className: "col-span-4 row-span-2",
            },
            {
              src: "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg",
              className: "",
            },
            {
              src: "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg",
              className: "",
            },
            {
              src: "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg",
              className: "col-span-2",
            },
          ],
          specificationsDefault: "Bronze",
          specifications: {
            Bronze: {
              image:
                "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg",
              details: [
                { label: "Plan", value: "Bronze" },
                { label: "Flammability", value: "Pass – Low Radius" },
                { label: "Thermal Insulation", value: "1.66 Tog" },
                {
                  label: "Sustainability",
                  value: "Fully Recyclable at End of Life",
                },
                {
                  label: "Sound Reduction (ISO0140)",
                  value: "Reduction of 45db",
                },
              ],
            },
            Silver: {
              image:
                "https://www.scio-automation.com/hubfs/Blogbeitrag%20Bilder%20%281%29.png",
              details: [
                { label: "Plan", value: "Silver" },
                { label: "Flammability", value: "Pass – Low Radius" },
                { label: "Thermal Insulation", value: "1.80 Tog" },
                {
                  label: "Sustainability",
                  value: "Fully Recyclable at End of Life",
                },
                {
                  label: "Sound Reduction (ISO0140)",
                  value: "Reduction of 50db",
                },
              ],
            },
            Gold: {
              image:
                "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg",
              details: [
                { label: "Plan", value: "Gold" },
                { label: "Flammability", value: "Pass – Low Radius" },
                { label: "Thermal Insulation", value: "1.80 Tog" },
                {
                  label: "Sustainability",
                  value: "Fully Recyclable at End of Life",
                },
                {
                  label: "Sound Reduction (ISO0140)",
                  value: "Reduction of 50db",
                },
              ],
            },
          },
          mainScrollText: {
            text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste officiis labore asperiores, libero ab explicabo quam ea tenetur. Ut molestias suscipit enim pariatur ipsum impedit laborum eligendi sunt culpa odit!",
            className: "py-20 px-6 md:px-0",
            author: "jon doe",
            position: "CEO",
            bgColor: "#eee",
            fgColor: "black",
            fontSize: "text-6xl",
            authorColor: "text-white",
            forward: false,
          },
          faq: {
            title: "Frequently asked questions about a service",
            link: "/contact",
            label: "Contact Us",
          },
          service_guid: {
            title: "Service Video",
            video:
              "https://www.youtube.com/embed/M8xHJO3B1nY?si=qP5qwJn040_IkCFf",
          },
          relatedServiceHeading: "Relative Service",
          contactFormInfo: {
            bgImage:
              "https://images.pexels.com/photos/255379/pexels-photo-255379.jpeg?cs=srgb&dl=pexels-padrinan-255379.jpg&fm=jpg",
            title: "Want to see if it will work for you?",
            subtitle:
              "We have a wide range of products to suit various needs, but if you can’t find exactly what you’re after, get in touch with us and we’ll be happy to assist you with your specific requirements.",
          },
          madeForList: [
            { title: "Homes", content: "Description for Homes" },
            { title: "Hotels", content: "Description for Hotels" },
            {
              title: "House Builders",
              content: "Description for House Builders",
            },
            {
              title: "Commercial Spaces",
              content: "Description for Commercial Spaces",
            },
          ],
          faqList: [
            { title: "why are you here", content: "Description for Homes" },
            { title: "whats going on here", content: "Description for Hotels" },
            {
              title: "what are you doing",
              content: "Description for House Builders",
            },
            {
              title: "who are you",
              content: "Description for Commercial Spaces",
            },
          ],
        },
      ],
    },
    productData: {
      productHeading: "products",
      bgImage:
        "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg",
      productList: [
        {
          id: 1,
          title: "lorem ipsum dolor sit amet, consectetur adipiscing",
          subtitle: "lorem ipsum dolor",
          sector: "Apparel",
          brand: "Delta",
          imageUrl:
            "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg",
          bannerImageUrl:
            "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg",
          hightLight_text:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corporis ab, iste natus fuga, qui voluptate dolor beatae esse nesciunt ad autem error, temporibus accusantium eos tempora! Inventore similique esse nostrum!",
          buttonText: "More Details",
          description: [
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem nostrum doloremque nihil qui, dolores voluptatum distinctio a! Ducimus tempora nisi minus dolore! Omnis facere illo blanditiis quis eius, quibusdam dicta.",
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem nostrum doloremque nihil qui, dolores voluptatum distinctio a! Ducimus tempora nisi minus dolore! Omnis facere illo blanditiis quis eius, quibusdam dicta.",
          ],
          madeFor: "Made for",
          images: [
            {
              src: "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg",
              className: "col-span-4 row-span-2",
            },
            {
              src: "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg",
              className: "",
            },
            {
              src: "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg",
              className: "",
            },
            {
              src: "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg",
              className: "col-span-2",
            },
          ],
          specificationsDefault: "7mm",
          specifications: {
            "7mm": {
              image:
                "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg",
              details: [
                { label: "Thickness", value: "7mm" },
                { label: "Flammability (BS 4790)", value: "Pass – Low Radius" },
                { label: "Thermal Insulation", value: "1.66 Tog" },
                {
                  label: "Sustainability",
                  value: "Fully Recyclable at End of Life",
                },
                {
                  label: "Sound Reduction (ISO0140)",
                  value: "Reduction of 45db",
                },
              ],
            },
            "8mm": {
              image:
                "https://www.scio-automation.com/hubfs/Blogbeitrag%20Bilder%20%281%29.png",
              details: [
                { label: "Thickness", value: "8mm" },
                { label: "Flammability", value: "Pass – Low Radius" },
                { label: "Thermal Insulation", value: "1.80 Tog" },
                {
                  label: "Sustainability",
                  value: "Fully Recyclable at End of Life",
                },
                {
                  label: "Sound Reduction (ISO0140)",
                  value: "Reduction of 50db",
                },
              ],
            },
          },
          mainScrollText: {
            text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste officiis labore asperiores, libero ab explicabo quam ea tenetur. Ut molestias suscipit enim pariatur ipsum impedit laborum eligendi sunt culpa odit!",
            className: "py-20 px-6 md:px-0",
            author: "jon doe",
            position: "CEO",
            bgColor: "#eee",
            fgColor: "black",
            fontSize: "text-6xl",
            authorColor: "text-white",
            forward: false,
          },
          faq: {
            title: "Frequently asked questions about a product",
            link: "/contact",
            label: "Contact Us",
          },
          installation: {
            title: "installation guide",
            video:
              "https://www.youtube.com/embed/M8xHJO3B1nY?si=qP5qwJn040_IkCFf",
          },
          relatedproductHeading: "Relative product",
          contactFormInfo: {
            bgImage:
              "https://images.pexels.com/photos/255379/pexels-photo-255379.jpeg?cs=srgb&dl=pexels-padrinan-255379.jpg&fm=jpg",
            title: "Want to see if it will work for you?",
            subtitle:
              "We have a wide range of products to suit various needs, but if you can’t find exactly what you’re after, get in touch with us and we’ll be happy to assist you with your specific requirements.",
          },
          madeForList: [
            { title: "Homes", content: "Description for Homes" },
            { title: "Hotels", content: "Description for Hotels" },
            {
              title: "House Builders",
              content: "Description for House Builders",
            },
            {
              title: "Commercial Spaces",
              content: "Description for Commercial Spaces",
            },
          ],
          faqList: [
            { title: "why are you here", content: "Description for Homes" },
            { title: "whats going on here", content: "Description for Hotels" },
            {
              title: "what are you doing",
              content: "Description for House Builders",
            },
            {
              title: "who are you",
              content: "Description for Commercial Spaces",
            },
          ],
        },
      ],
    },
    contactData: {
      contactFormInfo: {
        bgImage:
          "https://images.unsplash.com/photo-1615457938971-3ab61c1c0d57?fm=jpg",
        title: "Contact Us",
        subtitle: "We’re here to serve you, Please get in touch…",
      },
      directionLink:
        "https://www.google.com/maps/place/Inovia+Automation/@18.795146,73.310082,17z/data=!4m6!3m5!1s0x3be8078bd67623e9:0x4f7c9ad529eacdbb!8m2!3d18.7951459!4d73.3100823!16s%2Fg%2F11r4jf32dd?hl=en&entry=ttu&g_ep=EgoyMDI1MDMxOC4wIKXMDSoASAFQAw%3D%3D",
    },
    commonData: {
      contactDetails: {
        contact: "9561555464",
        email: "inoviaautomation@gmail.com",
      },
      addressInfo: {
        address: "INOVIA AUTOMATION SHOP NO.1 OPPOSITE DHARTI COMPLEX,KHOPOLI -ADOSHI ROAD,TAKAI",
        city: "Khopoli",
        postalCode: "410203",
        state: "Maharashtra",
        country: "India",
      },
      locationInfo: {
        locationLink:
          "https://www.google.com/maps/place/Inovia+Automation/@18.795146,73.310082,17z/data=!4m6!3m5!1s0x3be8078bd67623e9:0x4f7c9ad529eacdbb!8m2!3d18.7951459!4d73.3100823!16s%2Fg%2F11r4jf32dd?hl=en&entry=ttu&g_ep=EgoyMDI1MDMxOC4wIKXMDSoASAFQAw%3D%3D",
        mapLocationLink:
          "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.1234567890123!2d73.3100823!3d18.7951459!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be8078bd67623e9%3A0x4f7c9ad529eacdbb!2sInovia%20Automation!5e0!3m2!1sen!2sin!4v1610000000000!5m2!1sen!2sin",
      },
      navigation: {
        menuItems: [
          { label: "Home", link: "/" },
          { label: "About Us", link: "/about" },
          { label: "Services", link: "/services" },
          { label: "Products", link: "/products" },
          { label: "Contact Us", link: "/contact" },
        ],
        socialMediaLinks: [
          { link: "https://www.linkedin.com/feed/" },
          { link: "https://www.facebook.com/inoviaautomation" },
          { link: "https://www.instagram.com/inoviaautomation" },
          { link: "https://www.youtube.com/@inoviaautomation/" },
        ],
      },
      footerLinks: [
        { label: "Terms & Conditions", link: "/terms-and-conditions" },
        { label: "Privacy Policy", link: "/privacy-policy" },
        { label: "FAQs", link: "/faqs" },
      ],
      companyDetails: {
        name: "Inovia Automation",
        description:
          "Inovia Automation is a leading Industrial Automation Supplier with Engineering solutions!",
        logoImageUrl:
          "https://5.imimg.com/data5/SELLER/Logo/2020/10/DW/IH/UP/42713251/original-120x120.png",
      },
    },
  },
}));

export default useStore;
